/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three';
import React, { useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { const_var, params } from '../../../../../../redux/reducers/reducer'
import { delModel, extrudeSettings, jTrimModel, wainscotTrimModel } from '../../../../../../utils/Functions';
import { CSG } from '../../../../../../assets/libs/csg-lib';
import { setWallCloseStateWrap } from '../../../../../../action';
import { controls } from '../../../../../../redux/reducers/eventReducer';

const TrimModel = () => {
    const dispatch = useDispatch();

    const wallCloseStateWrap = useSelector(state => state.reducer.wallCloseStateWrap)
    
    const [wallCloseState, setWallCloseState] = useState(0);
    const [leftStorageWallHeight, setLeftStorageWallHeight] = useState(params.p_h);
    const [rightStorageWallHeight, setRightStorageWallHeight] = useState(params.p_h);

    // const wainscotColor = useMemo(() => {
    //     if ((const_var.activeTab === 'doorwindow' && const_var.focusedSection !== 'center' && const_var.focusedSection !== '') || (params.is_translusant)/* || (const_var.activeTab === 'walls' && params.p_u_c)*/) {
    //         return 'white'
    //     } else {
    //         return params.p_w_c_c.replace("0x","#");
    //     }
    // }, [params.p_w_c_c, const_var.activeTab, const_var.focusedSection, params.is_translusant, params.p_u_c])
    const wainscotColor = useMemo(() => (params.p_w_c_c.replace("0x","#")), [params.p_w_c_c]) 

    const leftHeight = useMemo(() => ((params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p / 12) * params.p_w) :  params.p_h), [params.singleSlope, params.freeStandingSide, params.p_w, params.p_h, params.p_r_p])

    const leftTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        
        let overHeight = 0;
        if (params.p_r_s === 1) {
            overHeight = 0;
        } else {
            overHeight = -0.1
        }

        if (!params.add_left_lean && params.cB_addStorage_check_left) {
            model.moveTo(-(params.p_w / 2 + 0.075), 0);
            model.lineTo(-(params.p_w / 2 + 0.075), (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
            model.lineTo(-(params.p_w / 2 - 0.15), (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
            model.lineTo(-(params.p_w / 2 - 0.15), 0);
            model.closePath();
        } else {
            if((params.add_left_lean && params.leantoAlignmentLeft == 2 && !(params.p_b_c_b_l_f === 'Open'))
                || (params.add_left_lean && (params.leantoAlignmentLeft == 1 || params.leantoAlignmentLeft == 3) && !(params.p_b_c_b_l_f === 'Open') && params.p_d === params.lean_p_d)
            ){
                if (wallCloseState > -1 && !params.cB_addStorage_check_left) { 
                    model.moveTo(-(params.p_w / 2 + 0.075), wallCloseStateWrap.LLFrontWallCloseState + 0.1);
                    model.lineTo(-(params.p_w / 2 + 0.075), wallCloseState);
                    model.lineTo(-(params.p_w / 2 - 0.15), wallCloseState);
                    model.lineTo(-(params.p_w / 2 - 0.15), wallCloseStateWrap.LLFrontWallCloseState + 0.1);
                    model.closePath();
                } 
            } else{
                if (wallCloseState > -1 ) {
                    model.moveTo(-(params.p_w / 2 + 0.075), wallCloseState);
                    model.lineTo(-(params.p_w / 2 + 0.075), (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
                    model.lineTo(-(params.p_w / 2 - 0.15), (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
                    model.lineTo(-(params.p_w / 2 - 0.15), wallCloseState);
                    model.closePath();
                }
            }
        }

        return model;
    
    }, [params.p_d,params.p_h, wallCloseState, params.p_w, params.p_r_p, params.p_r_s, params.p_r_p, params.cB_addStorage_check_left,params.singleSlope && params.freeStandingSide === "left", params.leantoAlignmentLeft, params.add_left_lean, params.p_b_c_b_l_f, params.p_d, params.lean_p_d, wallCloseStateWrap.LLFrontWallCloseState])

    const rightTrimModel = useMemo(() => {
        const model = new THREE.Shape();

        let overHeight = 0;
        if (params.p_r_s === 1) {
            overHeight = 0;
        } else {
            overHeight = -0.1
        }

        if (!params.add_right_lean && params.cB_addStorage_check_right) {
            model.moveTo(params.p_w / 2 - 0.15, 0);
            model.lineTo(params.p_w / 2 - 0.15, (params.singleSlope && params.freeStandingSide === "right") ? params.p_h + ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
            model.lineTo(params.p_w / 2 + 0.075, (params.singleSlope && params.freeStandingSide === "right") ? params.p_h + ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
            model.lineTo(params.p_w / 2 + 0.075, 0);
            model.closePath();
        } else if((params.add_right_lean && params.leantoAlignmentRight == 2 && !(params.p_b_c_b_r_f === 'Open'))
            || (params.add_right_lean && (params.leantoAlignmentRight == 1 || params.leantoAlignmentRight == 3) && !(params.p_b_c_b_r_f === 'Open') && params.p_d === params.leanR_p_d)
        ){
            if (wallCloseState > -1 && !params.cB_addStorage_check_right) {
                model.moveTo((params.p_w / 2 + 0.075), wallCloseStateWrap.RLFrontWallCloseState + 0.1);
                model.lineTo((params.p_w / 2 + 0.075), wallCloseState);
                model.lineTo((params.p_w / 2 - 0.15), wallCloseState);
                model.lineTo((params.p_w / 2 - 0.15), wallCloseStateWrap.RLFrontWallCloseState + 0.1);
                model.closePath();
                
            }
        }  
        else {
            if (wallCloseState > -1) {    
                model.moveTo(params.p_w / 2 - 0.15, wallCloseState);
                model.lineTo(params.p_w / 2 - 0.15, (params.singleSlope && params.freeStandingSide === "right") ? params.p_h + ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
                model.lineTo(params.p_w / 2 + 0.075, (params.singleSlope && params.freeStandingSide === "right") ? params.p_h + ((params.p_r_p / 12) * params.p_w) + overHeight : params.p_h + overHeight);
                model.lineTo(params.p_w / 2 + 0.075, wallCloseState);
                model.closePath();
            }
        }

        return model;
    
    }, [params.p_d,params.p_h, wallCloseState, params.p_w, params.p_r_p, params.p_r_s, params.cB_addStorage_check_right, params.singleSlope, params.leantoAlignmentRight, params.add_right_lean, params.p_b_c_b_r_f, params.leanR_p_d, wallCloseStateWrap.RLFrontWallCloseState ])
    
    const leftLeanRightTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        
            if((params.add_left_lean && params.leantoAlignmentLeft == 2 && !(params.p_b_c_b_l_f === 'Open'))
                || (params.add_left_lean && (params.leantoAlignmentLeft == 1 || params.leantoAlignmentLeft == 3) && params.p_d === params.lean_p_d && !(params.p_b_c_b_l_f === 'Open'))){
  
                if (wallCloseState > -1) {
                    if(!params.cB_addStorage_check_left){
                        model.moveTo(-(params.p_w / 2 + 0.075), wallCloseState);
                        model.lineTo(-(params.p_w / 2 + 0.075), wallCloseStateWrap.LLFrontWallCloseState + 0.1);
                        model.lineTo(-(params.p_w / 2 - 0.15), wallCloseStateWrap.LLFrontWallCloseState + 0.1);
                        model.lineTo(-(params.p_w / 2 - 0.15), wallCloseState);
                        model.closePath();
                    }
                } 
                // else {
                //     model.moveTo(-(params.p_w / 2 + 0.075), wallCloseStateWrap.LLFrontWallCloseState);
                //     model.lineTo(-(params.p_w / 2 + 0.075), params.p_h);
                //     model.lineTo(-(params.p_w / 2 - 0.15), params.p_h);
                //     model.lineTo(-(params.p_w / 2 - 0.15), wallCloseStateWrap.LLFrontWallCloseState);
                //     model.closePath();
                // }
            }
        return model;
    
    }, [params.p_h, wallCloseState, params.p_w, params.p_r_p, params.p_r_s, params.p_r_p, params.cB_addStorage_check_left,params.singleSlope && params.freeStandingSide === "left", params.leantoAlignmentLeft, params.add_left_lean, params.p_b_c_b_l_f, wallCloseStateWrap.LLFrontWallCloseState, params.p_f_w, params.p_d, params.lean_p_d])

    const RightLeanLeftTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        
            if((params.add_right_lean && params.leantoAlignmentRight == 2 && !(params.p_b_c_b_r_f === 'Open'))
                || (params.add_right_lean && (params.leantoAlignmentRight == 1 || params.leantoAlignmentRight == 3) && params.p_d === params.leanR_p_d && !(params.p_b_c_b_r_f === 'Open'))){

                if (wallCloseState > -1) {
                    if(!params.cB_addStorage_check_right){
                        model.moveTo((params.p_w / 2 + 0.075), wallCloseState);
                        model.lineTo((params.p_w / 2 + 0.075), wallCloseStateWrap.RLFrontWallCloseState + 0.1);
                        model.lineTo((params.p_w / 2 - 0.15), wallCloseStateWrap.RLFrontWallCloseState + 0.1);
                        model.lineTo((params.p_w / 2 - 0.15), wallCloseState);
                        model.closePath();
                    }
                } 
                // else {
                //     model.moveTo((params.p_w / 2 + 0.075), wallCloseStateWrap.RLFrontWallCloseState);
                //     model.lineTo((params.p_w / 2 + 0.075), params.p_h);
                //     model.lineTo((params.p_w / 2 - 0.15), params.p_h);
                //     model.lineTo((params.p_w / 2 - 0.15), wallCloseStateWrap.RLFrontWallCloseState);
                //     model.closePath();
                // }
            }
        return model;
    
    }, [params.p_h, wallCloseState, params.p_w, params.p_r_p, params.p_r_s, params.p_r_p, params.cB_addStorage_check_left,params.singleSlope && params.freeStandingSide === "left", params.leantoAlignmentRight, params.add_right_lean, params.p_b_c_b_r_f, wallCloseStateWrap.RLFrontWallCloseState, params.p_f_w, params.p_d, params.leanR_p_d])

    const connectLeftTrimModel = useMemo(() => {
        const model = new THREE.Shape();
            if((params.add_left_lean && !(params.p_b_c_b_l_f === 'Open') && (wallCloseStateWrap.cbLeftWallCloseState <= wallCloseStateWrap.LLFrontWallCloseState) && (wallCloseStateWrap.cbLeftWallCloseState <= wallCloseState))
             || (params.add_left_lean && !(params.p_b_c_b_l_f === 'Open')  && params.p_f_w === 'Open' && (params.cB_addStorage_check_left || params.cB_addStorage_check_right))){
                model.moveTo(-(params.p_w / 2 + 0.075), wallCloseStateWrap.cbLeftWallCloseState);
                model.lineTo(-(params.p_w / 2 + 0.075), wallCloseStateWrap.LLFrontWallCloseState + 0.1);
                model.lineTo(-(params.p_w / 2 - 0.15), wallCloseStateWrap.LLFrontWallCloseState + 0.1);
                model.lineTo(-(params.p_w / 2 - 0.15), wallCloseStateWrap.cbLeftWallCloseState);
                model.closePath();
                
            }
        return model;
    
    }, [wallCloseStateWrap.cbLeftWallCloseState, params.p_w, wallCloseStateWrap.LLFrontWallCloseState, params.add_left_lean, params.p_b_c_b_l_f, wallCloseState, params.cB_addStorage_check_left, params.cB_addStorage_check_right, params.p_f_w])

    const connectRightTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        
        if((params.add_right_lean && !(params.p_b_c_b_r_f === 'Open') && (wallCloseStateWrap.cbRightWallCloseState <= wallCloseStateWrap.RLFrontWallCloseState) && (wallCloseStateWrap.cbRightWallCloseState <= wallCloseState))
        || (params.add_right_lean && !(params.p_b_c_b_r_f === 'Open')  && params.p_f_w === 'Open' && (params.cB_addStorage_check_left || params.cB_addStorage_check_right))){
                model.moveTo((params.p_w / 2 + 0.075), wallCloseStateWrap.cbRightWallCloseState);
                model.lineTo((params.p_w / 2 + 0.075), wallCloseStateWrap.RLFrontWallCloseState + 0.1);
                model.lineTo((params.p_w / 2 - 0.15), wallCloseStateWrap.RLFrontWallCloseState + 0.1);
                model.lineTo((params.p_w / 2 - 0.15), wallCloseStateWrap.cbRightWallCloseState);
                model.closePath();
                
        }
        return model;
    
    }, [wallCloseStateWrap.cbRightWallCloseState, params.p_w, wallCloseStateWrap.RLFrontWallCloseState, params.add_right_lean, params.p_b_c_b_r_f, wallCloseState, params.cB_addStorage_check_left, params.cB_addStorage_check_right, params.p_f_w])

    const leftStorageTrimModelOne = useMemo(() => {
        const model = new THREE.Shape();
        
        if (params.cB_addStorage_check_left) {
            model.moveTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left) - 0.18, 0);

            if (wallCloseState > -1) {
                model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left) - 0.18, wallCloseState + (params.p_j_t_end ? 0.1 : 0));
            }
    
            if (wallCloseState === -1) {
                model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left) - 0.18, leftStorageWallHeight - 0.1);
                model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left) + 0.07, leftStorageWallHeight - 0.1);
            }

            if (wallCloseState > -1) {
                model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left) + 0.07, wallCloseState + (params.p_j_t_end ? 0.1 : 0));
            }

            model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left) + 0.07, 0);
            model.closePath();
        }

        return model;
    
    }, [wallCloseState, params.p_w, params.p_r_p, params.cB_addStorage_check_left, params.cB_addStorage_left, leftStorageWallHeight, params.p_j_t_end])

    const leftStorageTrimModelTwo = useMemo(() => {
        const model = new THREE.Shape();
        
        if (params.cB_addStorage_check_left) {
            model.moveTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left), 0);

            if (wallCloseState > -1) {
                model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left), wallCloseState);
            }
    
            if (wallCloseState === -1) {
                model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left), leftStorageWallHeight - 0.1);
                model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left) + 0.07, leftStorageWallHeight - 0.1);
            }

            if (wallCloseState > -1) {
                model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left) + 0.07, wallCloseState);
            }

            model.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left) + 0.07, 0);
            model.closePath();
        }

        return model;
    
    }, [wallCloseState, params.p_w, params.p_r_p, params.cB_addStorage_check_left, params.cB_addStorage_left, leftStorageWallHeight])

    const rightStorageTrimModelOne = useMemo(() => {
        const model = new THREE.Shape();
      
        if (params.cB_addStorage_check_right) {
            model.moveTo(params.p_w / 2 - parseInt(params.cB_addStorage_right) - 0.07, 0);

            if (wallCloseState > -1) {
                model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right) - 0.07, wallCloseState + (params.p_j_t_end ? 0.1 : 0));
            }
    
            if (wallCloseState === -1) {
                model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right) - 0.07, rightStorageWallHeight - 0.1);
                model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right) + 0.18, rightStorageWallHeight - 0.1);
            }

            if (wallCloseState > -1) {
                model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right) + 0.18, wallCloseState + (params.p_j_t_end ? 0.1 : 0));
            }

            model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right) + 0.18, 0);
            model.closePath();
        }

        return model;
    
    }, [wallCloseState, params.p_w, params.p_r_p, params.cB_addStorage_check_right, params.cB_addStorage_right, rightStorageWallHeight, params.p_j_t_end ])

    const rightStorageTrimModelTwo = useMemo(() => {
        const model = new THREE.Shape();
        
        if (params.cB_addStorage_check_right) {
            model.moveTo(params.p_w / 2 - parseInt(params.cB_addStorage_right) - 0.07, 0);

            if (wallCloseState > -1) {
                model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right) - 0.07, wallCloseState);
            }
    
            if (wallCloseState === -1) {
                model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right) - 0.07, rightStorageWallHeight - 0.1);
                model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right), rightStorageWallHeight - 0.1);
            }

            if (wallCloseState > -1) {
                model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right), wallCloseState);
            }

            model.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right), 0);
            model.closePath();
        }

        return model;
    
    }, [wallCloseState, params.p_w, params.p_r_p, params.cB_addStorage_check_right, params.cB_addStorage_right, rightStorageWallHeight])

    const dutchDelModel = useMemo(() => {
        const freeSpace = 1;
        const trimWidth = 0.2;
        const offset = 0.05 * Math.pow(2, 1 / 2)
        const cornerFreeSpaceW = freeSpace * 2;
        const leftHeight = (params.singleSlope && params.freeStandingSide === "left") ? params.p_h - ((params.p_r_p / 12) * params.p_w) :  params.p_h;
        let cornerFreeSpaceH = (leftHeight - freeSpace) / 6
        if (cornerFreeSpaceH > freeSpace) cornerFreeSpaceH = cornerFreeSpaceW;
        
        if (!params.cB_addStorage_check_right && !params.cB_addStorage_check_right && (params.p_f_w === "Half Dutch End" || params.p_f_w === "Half End")) {
            const model = new THREE.Shape();
            model.moveTo(-(params.p_w / 2 - freeSpace), 0);

            if (params.p_f_w === "Half Dutch End") {
                model.lineTo(-(params.p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
                model.lineTo(-(params.p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((params.p_w / 2 - freeSpace - cornerFreeSpaceW), leftHeight - freeSpace);
                model.lineTo((params.p_w / 2 - freeSpace), leftHeight - freeSpace - cornerFreeSpaceH);
                model.lineTo((params.p_w / 2 - freeSpace), 0);
                model.lineTo((params.p_w / 2 - freeSpace - trimWidth), 0);
                model.lineTo((params.p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - cornerFreeSpaceH - offset * Math.pow(2, 1 / 2));
                model.lineTo((params.p_w / 2 - freeSpace - cornerFreeSpaceW - offset), leftHeight - freeSpace - trimWidth);
                model.lineTo(-(params.p_w / 2 - freeSpace - cornerFreeSpaceW - offset), leftHeight - freeSpace - trimWidth);
                model.lineTo(-(params.p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - cornerFreeSpaceH - offset * Math.pow(2, 1 / 2));
            } else {
                model.lineTo(-(params.p_w / 2 - freeSpace), leftHeight - freeSpace);
                model.lineTo((params.p_w / 2 - freeSpace), leftHeight - freeSpace);
                model.lineTo((params.p_w / 2 - freeSpace), 0);
                model.lineTo((params.p_w / 2 - freeSpace - trimWidth), 0);
                model.lineTo((params.p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - trimWidth);
                model.lineTo(-(params.p_w / 2 - freeSpace - trimWidth), leftHeight - freeSpace - trimWidth);
            }
            model.lineTo(-(params.p_w / 2 - freeSpace - trimWidth), 0);
            model.closePath()

            return model;
        } else {
            return []
        }
    }, [params.p_w, params.p_h, params.p_f_w, params.cB_addStorage_check_right , params.cB_addStorage_check_left])

    useMemo(() => {
        let wallCloseValue = -1;
        let leanHeightValue = -1;

        if (params.p_f_w === 'Open') {
            wallCloseValue = -1;
        } else if (params.p_f_w === "Gable") {
            wallCloseValue = leftHeight - 0.2;
        } else if (params.p_f_w === "Extended Gable") {
            wallCloseValue = leftHeight - 3;
        } else if (params.p_f_w === "One_Fourth_Close") {
            wallCloseValue = (leftHeight * 3) / 4;
        } else if (params.p_f_w === "Half_Close") {
            wallCloseValue = leftHeight / 2;
        } else if (params.p_f_w === "Three_Fourth_Close") {
            wallCloseValue = leftHeight / 4;
        } else if (params.p_f_w === "Close" || params.p_f_w === "Half Dutch End" || params.p_f_w === "Half End") {
            wallCloseValue = 0;
        }

        if (params.add_front_lean) {
            let leanFinalHeight = params.p_h - (params.leanF_p_h + (parseInt(params.b_l_t_r_pF)/12) * params.leanF_p_w);
            if(params.add_front_lean ==true && Object.values(const_var.wallArray["front"])[0] == params.p_f_w || params.add_front_lean ==true && params.p_f_w == "Open")
            {    
              params.p_f_w = params.p_f_wF
              let wH = leanFinalHeight+0.2;
              setWallCloseState(params.p_h - wH);
              dispatch(setWallCloseStateWrap({'cbFrontWallCloseState': params.p_h - wH}))
            }else{
                setWallCloseState(wallCloseValue);
                dispatch(setWallCloseStateWrap({'cbFrontWallCloseState': wallCloseValue}))
            }
        } else {
            setWallCloseState(wallCloseValue);
            dispatch(setWallCloseStateWrap({'cbFrontWallCloseState': wallCloseValue}))
        }

    
    }, [params.p_f_w, params.p_r_p, leftHeight, params.add_front_lean, params.leanF_p_h, params.b_l_t_r_pF, params.leanF_p_w, JSON.stringify(const_var.wallArray)])

    useMemo(() => {
        if (params.cB_addStorage_check_left) {
            let overHeight = 0;
            if ((parseInt(params.cB_addStorage_left) < params.p_w / 2) || (params.singleSlope && (params.freeStandingSide === "left" || params.freeStandingSide === "right"))) {
                if (params.p_r_s === 1) {
                    overHeight = (parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12 + 0.4;
                } else {
                    overHeight = (parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12;
                }
            } else {
                if (params.p_r_s === 1) {
                    overHeight = (params.p_w - parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12 + 0.4;
                } else {
                    overHeight = (params.p_w - parseInt(params.cB_addStorage_left) + 0.0075) * params.p_r_p / 12;
                }
            }
    
            setLeftStorageWallHeight(leftHeight + overHeight);
        } else {
            setLeftStorageWallHeight(0);
        }
    
    }, [params.cB_addStorage_check_left, params.cB_addStorage_left, params.p_r_s, params.p_r_p, params.p_w, leftHeight])

    useMemo(() => {
        if (params.cB_addStorage_check_right) {
            let overHeight = 0;
            if (parseInt(params.cB_addStorage_right) < params.p_w / 2 && !params.singleSlope) {
                if (params.p_r_s === 1) {
                    overHeight = (parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12 + 0.4;
                } else {
                    overHeight = (parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12;
                }
            } else {
                if (params.p_r_s === 1) {
                    overHeight = (params.p_w - parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12 + 0.4;
                } else {
                    overHeight = (params.p_w - parseInt(params.cB_addStorage_right) + 0.0075) * params.p_r_p / 12;
                }
            }
    
            setRightStorageWallHeight(leftHeight + overHeight);
        } else {
            setRightStorageWallHeight(0);
        }
    
    }, [params.cB_addStorage_check_right, params.cB_addStorage_right, params.p_r_s, params.p_r_p, params.p_w, leftHeight])

    /**********************cutting hole using CSG************************/

    const mainTrimModel = useMemo(() => {

        const storageDelShape = new THREE.Shape();
            if(params.cB_addStorage_check_left) {
                storageDelShape.moveTo(-params.p_w / 2 - 0.075, 0);
                storageDelShape.lineTo(-params.p_w / 2 - 0.075, params.p_h);
                storageDelShape.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left), params.p_h)
                storageDelShape.lineTo(-params.p_w / 2 + parseInt(params.cB_addStorage_left), 0);
                storageDelShape.closePath();

            } else if(params.cB_addStorage_check_right) {
                storageDelShape.moveTo(params.p_w / 2 + 0.075, 0);
                storageDelShape.lineTo(params.p_w / 2 + 0.075, params.p_h);
                storageDelShape.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right), params.p_h)
                storageDelShape.lineTo(params.p_w / 2 - parseInt(params.cB_addStorage_right), 0);
                storageDelShape.closePath();
            }

        const meshJTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(jTrimModel(0.14, 0.2), extrudeSettings(params.p_w + 0.15)), new THREE.MeshStandardMaterial({ color: 'red' }))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('front', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'blue' }))
        const meshStorageDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(storageDelShape, extrudeSettings(1)))
    
        const meshJTrimModel_Temp = meshJTrimModel.clone();
        meshJTrimModel_Temp.rotation.y = Math.PI/-2
        meshJTrimModel_Temp.position.set((params.p_w / 2 + 0.075), wallCloseState + 0.1, (params.p_d / 2 + 0.1525));
        meshJTrimModel_Temp.updateMatrixWorld();
    
        const meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.position.set(0, 0, params.p_d / 2);
        meshDelModel_Temp.updateMatrixWorld();

        const meshStorageDelModel_Temp = meshStorageDelModel.clone();
        meshStorageDelModel_Temp.position.set(0, 0, params.p_d / 2 - 0.5)
        meshStorageDelModel_Temp.updateMatrixWorld();
    
        const meshJTrimModel_CSG = CSG.fromMesh(meshJTrimModel_Temp);
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);
        const meshStorageDelModel_CSG = CSG.fromMesh(meshStorageDelModel_Temp);
    
        const JTrimModel_CSG = meshJTrimModel_CSG.subtract(meshDelModel_CSG);
        const StorageDelModel_CSG = JTrimModel_CSG.subtract(meshStorageDelModel_CSG);
        
        const CSGJTrimModel = CSG.toMesh(
            StorageDelModel_CSG,
            new THREE.Matrix4()
        )
    
        /**********************cutting hole using CSG************************/
        const leftStorageWidth = (params.cB_addStorage_check_left && params.p_f_w !== "Close") ? params.p_w - params.cB_addStorage_left : 0
        const rightStorageWidth = (params.cB_addStorage_check_right && params.p_f_w !== "Close") ? params.p_w - params.cB_addStorage_right : 0
        const meshWainscotTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(params.p_w - leftStorageWidth - rightStorageWidth)), new THREE.MeshStandardMaterial({ color: 'red' }))
        const meshWainscotDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('front', 'wall'), extrudeSettings(1)), new THREE.MeshStandardMaterial({ color: 'blue' }))
    
        const meshWainscotTrimModel_Temp = meshWainscotTrimModel.clone();
        meshWainscotTrimModel_Temp.rotation.y = Math.PI/-2
        meshWainscotTrimModel_Temp.position.set((params.p_w / 2) - leftStorageWidth, 3, (params.p_d / 2 + 0.155));
        meshWainscotTrimModel_Temp.updateMatrixWorld();
    
        const meshWainscotDelModel_Temp = meshWainscotDelModel.clone();
        meshWainscotDelModel_Temp.position.set(0, 0, params.p_d / 2);
        meshWainscotDelModel_Temp.updateMatrixWorld();
    
        const meshWainscotTrimModel_CSG = CSG.fromMesh(meshWainscotTrimModel_Temp);
        const meshWainscotDelModel_CSG = CSG.fromMesh(meshWainscotDelModel_Temp);
    
        const wainscotTrimModel_CSG = meshWainscotTrimModel_CSG.subtract(meshWainscotDelModel_CSG);
        const CSGwainscotTrimModel = CSG.toMesh(
            wainscotTrimModel_CSG,
            new THREE.Matrix4()
        )

        // setCSGJTrimModelGeometry(CSGJTrimModel.geometry);
        // setCSGwainscotTrimModelGeometry(CSGwainscotTrimModel.geometry);

        return {
            jTrim: CSGJTrimModel.geometry,
            wTrim: CSGwainscotTrimModel.geometry,
        }

    }, [params.p_d, params.p_w, params.cB_addStorage_left, params.cB_addStorage_right, params.cB_addStorage_check_left, params.cB_addStorage_check_right, params.p_f_w, const_var.newDoorsArray,wallCloseState, params.p_h]);

    const mainColor = useMemo(() => params.p_t_c.replace('0x', '#'), [params.p_t_c]);

    return (
        <group name='trim-group' >
            <mesh name="front-left-trim" position={[0, 0, params.p_d / 2]}>
                <extrudeGeometry args={[leftTrimModel, extrudeSettings(0.23)]} />
                <meshStandardMaterial  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'center')} opacity={0.02} />
            </mesh>
            <mesh name="front-right-trim" position={[0, 0, params.p_d / 2 ]}>
                <extrudeGeometry args={[rightTrimModel, extrudeSettings(0.23)]} />
                <meshStandardMaterial  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'center')} opacity={0.02} />
            </mesh>
            <mesh name="left-lean-front-right-trim" position={[0, 0, params.p_d / 2 + 0.03]}>
                <extrudeGeometry args={[leftLeanRightTrimModel, extrudeSettings(0.2)]} />
                <meshStandardMaterial  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'center')} opacity={0.02} />
            </mesh>
            <mesh name="right-lean-front-left-trim" position={[0, 0, params.p_d / 2 + 0.03]}>
                <extrudeGeometry args={[RightLeanLeftTrimModel, extrudeSettings(0.2)]} />
                <meshStandardMaterial  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'center')} opacity={0.02} />
            </mesh>
            <mesh name="left-connect-trim" position={[0, 0, params.p_d / 2 + 0.03]}>
                <extrudeGeometry args={[connectLeftTrimModel, extrudeSettings(0.2)]} />
                <meshStandardMaterial  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'center')} opacity={0.02} />
            </mesh>
            <mesh name="right-connect-trim" position={[0, 0, params.p_d / 2 + 0.03]}>
                <extrudeGeometry args={[connectRightTrimModel, extrudeSettings(0.2)]} />
                <meshStandardMaterial  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'center')} opacity={0.02} />
            </mesh>
            {(params.p_f_w === 'Open' || params.p_f_w !== 'Close') && (
                <>
                    <mesh name="front-left-storage-trim-one" position={[0, 0, params.p_d / 2 + 0.23]}>
                        <extrudeGeometry args={[leftStorageTrimModelOne, extrudeSettings(-0.08)]} />
                        <meshStandardMaterial  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'center')} opacity={0.02} />
                    </mesh>
                    <mesh name="front-left-storage-trim-two" position={[0.01, 0, params.p_d / 2 + 0.225]}>
                        <extrudeGeometry args={[leftStorageTrimModelTwo, extrudeSettings(-0.225)]} />
                        <meshStandardMaterial  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'center')} opacity={0.02} />
                    </mesh>
                    <mesh name="front-right-storage-trim-one" position={[0, 0, params.p_d / 2 + 0.23]}>
                        <extrudeGeometry args={[rightStorageTrimModelOne, extrudeSettings(-0.08)]} />
                        <meshStandardMaterial  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'center')} opacity={0.02} />
                    </mesh>
                    <mesh name="front-right-storage-trim-two" position={[0, 0, params.p_d / 2 + 0.225]}>
                        <extrudeGeometry args={[rightStorageTrimModelTwo, extrudeSettings(-0.225)]} />
                        <meshStandardMaterial  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'center')} opacity={0.02} />
                    </mesh>
                </>
            )}
            {params.p_f_w !== 'Open' && !(params.p_f_w === "Close" || params.p_f_w === "Half Dutch End" || params.p_f_w === "Half End") && params.p_j_t_end && mainTrimModel.jTrim && (
                <mesh name="right-horizontal-trim" geometry={mainTrimModel.jTrim} >
                    <meshStandardMaterial  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'center')} opacity={0.02} />
                </mesh>
            )}
            {params.p_w_c_n === true && ((params.p_f_w === "Close") || (params.cB_addStorage_check_left) || (params.cB_addStorage_check_right)) && mainTrimModel.wTrim && (
                <mesh name="front_leg_wainscotRightTrim" geometry={mainTrimModel.wTrim}>
                    <meshStandardMaterial  color={wainscotColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} emissive={'#101010'} transparent={params.is_translusant || (controls.isCheckActiveTab == "doorwindow" && const_var.focusedSection !== 'center')} opacity={0.02} />
                </mesh>
            )}
            <mesh position={[0, 0, params.p_d / 2 + 0.075]}>
                <extrudeGeometry args={[dutchDelModel, extrudeSettings(0.15)]}/>
                <meshStandardMaterial  color={mainColor} side={THREE.DoubleSide} roughness={0.5} metalness={0.2} toneMapped={false} />
            </mesh>
        </group>
    )
}

export default TrimModel